import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/doc-diamant-fb.service';



export const listDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const getNextNumDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/next-num",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getNextNum(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const createDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createStockDiamantForcee = createAsyncThunk(
    "DocDiamantFB/adm-create-forcee",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createForcee(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createRetourDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-create-retour",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createRetour(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createSortieDiamant = createAsyncThunk(
    "DocDiamantFB/adm-create-sortie",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createSortie(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const transformeBonLivDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-transformeBonLiv",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.transformeBonLiv(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteDocDiamantFB = createAsyncThunk(
    "DocDiamantFB/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_DocDiamantFB: null
}

const DocDiamantFBSlice = createSlice({
    name: "DocDiamantFB",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = DocDiamantFBSlice;
export const { clear } = DocDiamantFBSlice.actions;
export default reducer;